import React, { useEffect, useContext } from "react";
import Popup from "reactjs-popup";
import { useWindowSize } from "@/hooks";
import { useTranslation } from "react-i18next";
import { MyContext } from "@/context.js";
import ErrorPopupThreeInOne from "./ThreeInOne";
import ErrorPopupRacing from "./Racing";
import ErrorPopupTV from "./TV";
import "./style.scss";
const ErorPopup = () => {
    const { isMobileSize } = useWindowSize();
    const { t } = useTranslation();
    let mobileStyle = isMobileSize ? "is-mobile" : "is-desktop";
    const {
        errorMessage,
        errorMessageTitle,
        errorMessageButtonText,
        showErrorPopup,
        type,
        toastApi,
        errorMessageConfirmButtonText,
        errorCallback,
        isShowButton = false,
    } = useContext(MyContext);
    useEffect(() => {
        if (isMobileSize) {
            mobileStyle = "is-mobile";
        } else {
            mobileStyle = "is-desktop";
        }
    }, [isMobileSize]);
    const handleClickClose = () => {
        if (errorCallback?.current?.handleConfirm) {
            errorCallback?.current?.handleConfirm();
            showErrorPopup("");
        } else {
            showErrorPopup("");
        }
        if (window.associateErrCode) {
            window.associateErrCode = null;
        }
    };
    const renderPopup = () => {
        switch (type) {
            case "wcip":
                return (
                    <Popup
                        closeOnEscape={!errorMessage?.isCloseOnEscape}
                        open={!!errorMessage}
                        closeOnDocumentClick={false}
                        className={`errorpopup-wcip ${mobileStyle}`}
                        onClose={handleClickClose}
                    >
                        <div
                            className="errorpopup-wcip-container"
                            id="errorpopup"
                        >
                            <div className="errorpopup-wcip-message">
                                {errorMessageTitle && (
                                    <div>{t(errorMessageTitle)}</div>
                                )}
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            typeof errorMessage === "string"
                                                ? `${t(errorMessage)
                                                      .replace(
                                                          "{loginname}",
                                                          window.username
                                                      )
                                                      .replace(
                                                          "({{code}})",
                                                          ""
                                                      )}${
                                                      window.associateErrCode
                                                          ? ` (${window.associateErrCode})`
                                                          : ""
                                                  }`
                                                : `${t(errorMessage?.msg, {
                                                      code: errorMessage?.code,
                                                  })}`,
                                    }}
                                ></div>
                            </div>
                            <div
                                className={`button-box errorpopup-wcip-btn-grp`}
                            >
                                <div className="row2">
                                    <div
                                        className="errorpopup-wcip-close"
                                        onClick={handleClickClose}
                                    >
                                        {t(
                                            errorMessageButtonText || "LB_CLOSE"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                );
            case "cssp":
                return (
                    <Popup
                        closeOnEscape={!errorMessage?.isCloseOnEscape}
                        open={!!errorMessage}
                        closeOnDocumentClick={false}
                        className={`errorpopup-cssp ${mobileStyle}`}
                        onClose={handleClickClose}
                    >
                        <div
                            className="errorpopup-cssp-container"
                            id="errorpopup"
                        >
                            {errorMessageTitle && (
                                <div className="errorpopup-cssp-message">
                                    <div className="errorpopup-cssp-title">
                                        {t(errorMessageTitle)}
                                    </div>
                                </div>
                            )}
                            {isShowButton ? (
                                <div
                                    className="errorpopup-cssp-message"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            typeof errorMessage === "string"
                                                ? errorMessage
                                                : `${t(errorMessage?.msg, {
                                                      code: errorMessage?.code,
                                                  })}`,
                                    }}
                                ></div>
                            ) : (
                                <div className="errorpopup-cssp-message">
                                    {t(
                                        typeof errorMessage === "string"
                                            ? errorMessage
                                            : errorMessage?.msg,
                                        { code: errorMessage?.code }
                                    ).replace("()", "")}
                                </div>
                            )}

                            <div
                                style={{
                                    width: "100%",
                                    padding: "20px 0px 0px 0px",
                                }}
                            >
                                <div className={`button-box `}>
                                    <div className="row2">
                                        {/* <div className="errorpopup-cssp-close" onClick={handleClickClose}>{t('LB_CLOSE')}</div> */}
                                        {
                                            <button
                                                id="testing"
                                                type="button"
                                                class="btn"
                                                onClick={handleClickClose}
                                            >
                                                {t(
                                                    errorMessageButtonText ||
                                                        "LB_CLOSE"
                                                )}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                );
            case "member":
                toastApi({
                    message: t(
                        typeof errorMessage === "string"
                            ? errorMessage
                            : errorMessage?.msg,
                        { code: errorMessage?.code }
                    ),
                    state: "error",
                    cbFunc: handleClickClose,
                });
                return <></>;
            default:
                return (
                    <Popup
                        open={!!errorMessage}
                        closeOnDocumentClick={false}
                        className={`${mobileStyle} ${type}_Popup`}
                        onClose={handleClickClose}
                    >
                        {type === "ThreeInOne" && (
                            <ErrorPopupThreeInOne
                                showErrorPopup={showErrorPopup}
                                title={errorMessageTitle}
                                content={errorMessage}
                                buttonText={errorMessageButtonText}
                                buttonConfirmText={
                                    errorMessageConfirmButtonText
                                }
                                errorCallback={
                                    errorCallback?.current?.handleConfirm
                                }
                                isShowButton={isShowButton}
                            ></ErrorPopupThreeInOne>
                        )}
                        {type === "Racing" && (
                            <ErrorPopupRacing
                                showErrorPopup={showErrorPopup}
                                title={errorMessageTitle}
                                content={errorMessage}
                                buttonText={errorMessageButtonText}
                                buttonConfirmText={
                                    errorMessageConfirmButtonText
                                }
                                errorCallback={
                                    errorCallback?.current?.handleConfirm
                                }
                                isShowButton={isShowButton}
                            ></ErrorPopupRacing>
                        )}
                        {type === "HKJCTV" && (
                            <ErrorPopupTV
                                showErrorPopup={showErrorPopup}
                                title={errorMessageTitle}
                                content={errorMessage}
                                buttonText={errorMessageButtonText}
                                buttonConfirmText={
                                    errorMessageConfirmButtonText
                                }
                                errorCallback={
                                    errorCallback?.current?.handleConfirm
                                }
                                isShowButton={isShowButton}
                            ></ErrorPopupTV>
                        )}
                    </Popup>
                );
        }
    };
    return <>{renderPopup()}</>;
};

export default ErorPopup;
